import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Head from "next/head";
import { checkWindow, getHome } from "@vfit/shared/data-access";
import { useRouter } from "next/router";
import { useCallback } from "react";
var DEFAULT_SEO_IMAGE_URL = "https://www.vodafone.it/portal/resources/media/Other/vfa/media/images/icone/ico_header_logo_red_04_12_19.png";
var HeadSeo = function(param) {
    var title = param.title, ogImageUrl = param.ogImageUrl, ogDescription = param.ogDescription, canonicalUrl = param.canonicalUrl, metaRobots = param.metaRobots, children = param.children;
    var router = useRouter();
    var getCanonicalDefault = useCallback(function() {
        if (!checkWindow()) return "";
        return "".concat(getHome()).concat(router.asPath === "/" ? "" : router.asPath).split("?")[0];
    }, []);
    var customMeta = metaRobots === "true" ? /*#__PURE__*/ _jsx("meta", {
        name: "robots",
        content: "noindex,nofollow"
    }) : "";
    return /*#__PURE__*/ _jsxs(Head, {
        children: [
            /*#__PURE__*/ _jsx("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ _jsx("title", {
                children: title
            }),
            /*#__PURE__*/ _jsx("meta", {
                name: "description",
                content: ogDescription
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "canonical",
                href: canonicalUrl || getCanonicalDefault()
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:image",
                content: ogImageUrl || DEFAULT_SEO_IMAGE_URL
            }),
            /*#__PURE__*/ _jsx("meta", {
                property: "og:description",
                content: ogDescription
            }),
            customMeta,
            children
        ]
    });
};
export default HeadSeo;
